import { constants } from '../../constants';
import {
    LoanFitchRating,
    LoanMoodysRating,
    LoanSnpRating,
    loanFitchRatingTitles,
    loanMoodysRatingTitles,
    loanSnpRatingTitles,
} from '../../types/enums/loan/LoanRatings';

interface RatingsCombinedProps {
    moodys?: LoanMoodysRating | null;
    snp?: LoanSnpRating | null;
    fitch?: LoanFitchRating | null;
}

export function RatingsCombined({ moodys, snp, fitch }: RatingsCombinedProps) {
    const titles = [
        moodys && loanMoodysRatingTitles[moodys],
        snp && loanSnpRatingTitles[snp],
        fitch && loanFitchRatingTitles[fitch],
    ];
    if (titles.every(t => !t)) return <>{constants.emptyPlaceholder}</>;

    const parts = titles.map(t => t || constants.emptyPlaceholder);
    return <span>{parts.join('/')}</span>;
}
